import { createAction, props } from '@ngrx/store';
import { IAVCFrequencyResponse } from '../../../static-data/models/avc-frequency.model';
import { Product } from '../models/manage-offerings.model';
import { IPFSettingsCurrentFileResponse, IPFSettingsPreviousFileResponse } from '../models/pf-settings-file.model';
import { IPFSetting, PFSetting } from '../models/pf-settings.model';
import { IProductSolutions } from '../models/product-solutions.model';

export const loadPFSettings = createAction('[PFSettings] Load PFSettings', props<{ request: string }>());

export const loadPFSettingsSuccess = createAction('[PFSettings] Load PFSettings Success', props<{ response: PFSetting[] }>());

export const loadPFSettingsFailure = createAction('[PFSettings] Load PFSettings Failure', props<{ error: Error | any }>());

export const loadClearPFSettings = createAction('[PFSettings] Clear PFSettings Failure');

//savePFSettings
export const savePFSettings = createAction('[PFSettings] Save PFSettings', props<{ businessId: string; request: IPFSetting }>());

export const savePFSettingsSuccess = createAction('[PFSettings] Save PFSettings Success', props<{ response: string }>());

export const savePFSettingsFailure = createAction('[PFSettings] Save PFSettings Failure', props<{ error: Error | any }>());

export const loadAVCFrequencyLookups = createAction('[AVCFrequencyLookups] Load AVCFrequencyLookups');

export const loadAVCFrequencyLookupsSuccess = createAction(
  '[AVCFrequencyLookups] Load AVCFrequencyLookups Success',
  props<{ response: IAVCFrequencyResponse[] }>()
);

export const loadAVCFrequencyLookupsFailure = createAction(
  '[AVCFrequencyLookups] Load AVCFrequencyLookups Failure',
  props<{ error: Error | any }>()
);

export const loadPFSettingsCurrentFile = createAction('[PFSettingsCurrentFile] Load PFSettingsCurrentFile', props<{ request: string }>());

export const loadPFSettingsCurrentFileSuccess = createAction(
  '[PFSettingsCurrentFile] Load PFSettingsCurrentFile Success',
  props<{ response: IPFSettingsCurrentFileResponse[] }>()
);

export const loadPFSettingsCurrentFileFailure = createAction(
  '[PFSettingsCurrentFile] Load PFSettingsCurrentFile Failure',
  props<{ error: Error | any }>()
);

export const loadPFSettingsPreviousFiles = createAction(
  '[PFSettingsPreviousFiles] Load PFSettingsPreviousFiles',
  props<{ request: string }>()
);

export const loadPFSettingsPreviousFilesSuccess = createAction(
  '[PFSettingsPreviousFiles] Load PFSettingsPreviousFiles Success',
  props<{ response: IPFSettingsPreviousFileResponse[] }>()
);

export const loadPFSettingsPreviousFilesFailure = createAction(
  '[PFSettingsPreviousFiles] Load PFSettingsPreviousFiles Failure',
  props<{ error: Error | any }>()
);
